dialog.c-modal {
  background-color: transparent;
  border: none;
  color: var(--c-text-body);
  inset: 0;
  margin: auto;
  max-width: calc(100% - 32px);
  overflow: visible;
  padding: 0;
  width: var(--_c-modal-width, 600px);

  &:not([open]) {
    pointer-events: none;
    opacity: 0;
  }

  &::backdrop {
    background-color: transparent;
  }

  &--standalone {
    &::backdrop {
      background-color: rgba(0, 0, 0, 0.5);
    }

    &.c-modal--backdrop-blur::backdrop {
      backdrop-filter: blur(4px);
    }
  }
}

@media (prefers-reduced-motion: no-preference) {
  dialog {
    &.nudging {
      animation: dialog-nudge 0.15s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
    }

    &.opening {
      animation: dialog-open 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) forwards;
    }

    &.closing {
      animation: dialog-close 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) forwards;
    }
  }
}

@keyframes dialog-nudge {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes dialog-open {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

@keyframes dialog-close {
  to {
    transform: scale(0);
  }
}
